import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import SupplierService from "../../services/SupplierService";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

const statusOptions = [
  { label: "Aktif", value: 1 },
  { label: "Pasif", value: 0 },
];

export default function SuppliersListPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadSuppliers();
  }, []);

  const loadSuppliers = async () => {
    try {
      setLoading(true);
      const res = await SupplierService.getAllSuppliers();
      setSuppliers(res);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Tedarikçiler yüklenemedi!",
      });
    } finally {
      setLoading(false);
    }
  };

  const actionsTemplate = (rowData) => (
    <div className="flex gap-2 justify-center">
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-text p-button-warning hover:bg-amber-50 w-8 h-8 p-0"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/suppliers/edit/${rowData.id}`);
        }}
        tooltip="Düzenle"
      />
    </div>
  );

  const balanceTemplate = (row) => {
    const val = row.balance || 0;
    const formatted = val.toLocaleString("tr-TR", {
      style: "currency",
      currency: "TRY"
    });

    return (
      <span className={`font-bold ${val > 0 ? "text-red-600" : val < 0 ? "text-emerald-600" : "text-slate-400"}`}>
        {formatted}
      </span>
    );
  };

  const detailButtonTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-eye"
        className="p-button-rounded p-button-text p-button-info hover:bg-blue-50 w-8 h-8 p-0"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/suppliers/detail/${rowData.id}`)
        }}
      />
    );
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    taxNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    useDueTracking: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-between items-center px-4 py-2 bg-slate-50 border-b border-slate-200">
        <span className="p-input-icon-left w-full md:w-80">
          <i className="pi pi-search text-slate-400 ml-3" />
          <InputText
            value={filters["global"].value || ""}
            onChange={onGlobalFilterChange}
            placeholder="Hızlı tedarikçi ara..."
            className="w-full rounded-xl border-slate-200 text-sm py-2 pl-10"
          />
        </span>
        <div className="flex gap-2">
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Temizle"
            className="p-button-outlined p-button-secondary p-button-sm rounded-xl ml-3"
            onClick={() =>
              setFilters({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                taxNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                email: { value: null, matchMode: FilterMatchMode.CONTAINS },
                recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
                useDueTracking: { value: null, matchMode: FilterMatchMode.EQUALS },
              })
            }
          />
        </div>
      </div>
    );
  };

  return (
    <div className="  animate-fade-in  min-h-screen">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="!bg-slate-300 shadow-sm border border-slate-200 overflow-hidden rounded-2xl  ">
        <div className="px-4 py-4 border-b border-slate-100   flex flex-col md:flex-row md:items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <div className="!bg-blue-600 p-4 rounded-xl shadow-md shadow-blue-500/20">
              <i className="pi pi-building text-white text-lg"></i>
            </div>
            <div>
              <h1 className="text-xl font-black text-slate-900 uppercase tracking-tight">Tedarikçi Listesi</h1>
              <p className="text-slate-400 text-xs font-bold italic">Tedarikçi hesapları ve bakiye yönetimi</p>
            </div>
          </div>
          <div className="flex gap-3">
            <Button
              label="EXCEL'DEN IMPORT ET"
              icon="pi pi-file-excel"
              className="!bg-emerald-600 border-none hover:!bg-emerald-700 px-5 py-2.5 rounded-xl font-black text-xs shadow-lg shadow-emerald-500/20 transition-all active:scale-95"
              onClick={() => navigate("/suppliers/import")}
            />
            <Button
              label="YENİ TEDARİKÇİ"
              icon="pi pi-plus"
              className="!bg-blue-600 border-none hover:!bg-blue-700 rounded-xl px-5 py-2.5 font-black text-sm shadow-lg shadow-blue-500/20 transition-all hover:scale-[1.02]"
              onClick={() => navigate("/suppliers/add")}
            />
          </div>
        </div>
      </div>

      <div className="bg-white shadow-sm border border-slate-200   overflow-hidden">
        <Card>
<DataTable
          value={suppliers}
          loading={loading}
          paginator
          rows={20}
          className="p-datatable-sm"
          filters={filters}
          onFilter={(e) => setFilters(e.filters)}
          filterDisplay="menu"
          globalFilterFields={["name", "taxNumber", "phoneNumber", "email"]}
          rowHover
          showGridlines
          responsiveLayout="scroll"
          emptyMessage="Tedarikçi bulunamadı."
          header={renderHeader()}
          paginatorClassName="border-t border-slate-100 px-4 py-2 bg-white"
          rowClassName={() => 'hover:bg-slate-50 transition-colors cursor-pointer'}
          onRowClick={(e) => navigate(`/suppliers/detail/${e.data.id}`)}
        >
          <Column field="id" header="ID" sortable className="text-slate-400 font-bold text-xs" style={{ width: '80px' }} />
          <Column
            field="name"
            header="TEDARİKÇİ ADI"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
            sortable
            filter
            filterPlaceholder="İsim ile ara..."
            className="text-slate-800 font-bold"
          /> 
          <Column
            field="phoneNumber"
            header="TELEFON"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
            sortable
            filter
            filterPlaceholder="Telefon ile ara..."
            className="text-slate-600 font-medium"
          />
          <Column
            field="email"
            header="E-POSTA"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
            sortable
            filter
            filterPlaceholder="E-posta ile ara..."
            className="text-slate-600 font-medium"
          />
          <Column field="balance" 
          header="BAKİYE" 
          body={balanceTemplate} 
          sortable 
          className="text-right font-black"
          headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
          />
          <Column
            header="HESAP TİPİ"
            field="useDueTracking"
            sortable
            filter
            className="text-center"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
            filterElement={(options) => (
              <Dropdown
                value={options.value}
                options={[
                  { label: "Vade Takipli", value: true },
                  { label: "Açık Hesap", value: false },
                ]}
                onChange={(e) => options.filterCallback(e.value)}
                placeholder="Seç"
                showClear
                className="w-full rounded-xl border-slate-200"
                appendTo={document.body}
              />
            )}
            body={(row) => (
              <Tag
                value={row.useDueTracking ? "VADE TAKİPLİ" : "AÇIK HESAP"}
                className="rounded-lg font-black text-[10px] px-3 py-1 border-none shadow-sm"
                style={{
                  backgroundColor: row.useDueTracking ? '#fef9c3' : '#f8fafc',
                  color: row.useDueTracking ? '#a16207' : '#475569',
                  border: row.useDueTracking ? '1px solid #fde047' : '1px solid #e2e8f0'
                }}
              />
            )}
          />
          <Column
            header="DURUM"
            field="recordStatus"
            sortable
            filter
            className="text-center"
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
            filterElement={(options) => (
              <Dropdown
                value={options.value}
                options={statusOptions}
                onChange={(e) => options.filterCallback(e.value)}
                placeholder="Seç"
                showClear
                className="w-full rounded-xl border-slate-200"
                appendTo={document.body}
              />
            )}
            body={(row) => (
              <Tag
                value={row.recordStatus === 1 ? "AKTİF" : "PASİF"}
                severity={row.recordStatus === 1 ? "success" : "secondary"}
                className="rounded-lg font-black text-[10px] px-3 py-1 border-none"
                style={{
                  backgroundColor: row.recordStatus === 1 ? '#dcfce7' : '#f1f5f9',
                  color: row.recordStatus === 1 ? '#166534' : '#64748b'
                }}
              />
            )}
          />
          <Column
            header="DETAY"
            body={detailButtonTemplate}
            style={{ width: "80px", textAlign: "center" }}
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
          />
          <Column
            header="İŞLEMLER"
            body={actionsTemplate}
            style={{ width: "60px", textAlign: "center" }} 
            headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
          />
        </DataTable>
        </Card>
        
      </div>
    </div>
  );
}
